import { Menu, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';

import { authClient } from '../../auth';
import { AuthContext } from '../../state/Context';

function UserMenu({ anchorEl, onClose }) {
  const { t } = useTranslation();
  const { tokens } = useContext(AuthContext);

  console.log(tokens);

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={() => authClient.signoutRedirect(tokens.idToken)}>
        <Typography sx={{ textAlign: 'center' }}>
          {t('components.user.logout')}
        </Typography>
      </MenuItem>
    </Menu>
  );
}

export default UserMenu;
